import React from "react";
import { Modal } from "antd";
import Button from "../../../components/Button/Button";
import ModalImg from "../../../assets/img/confirmation-modal-icon.svg";

interface deleteModelProps {
  handleConfirmDeleteModel?: () => void; // this closes and opens the model
  type: string;
  handleModelFunction?: () => void;
}

const ConfirmDeleteModal: React.FC<deleteModelProps> = ({
  handleConfirmDeleteModel,
  type,
  handleModelFunction,
}) => {
  let modalTitle = "";
  let modalMessage = "";

  if (type === "delete") {
    modalTitle = "Are you sure you want to delete this item?";
    modalMessage =
      "This action cannot be undone. Once deleted, the data will be permanently removed.";
  } else if (type === "confirm") {
    modalTitle = "You have successfully created a user for the organization!";
    modalMessage =
      "You can now proceed to add data elements for the user immediately, or you may choose to add them later at your convenience.";
  } else if (type === "reportUnlock") {
    modalTitle = "Are you sure you want to unlock this item?";
    modalMessage = "You can edit the submission after unlocking it.";
  }
  return (
    <div>
      <Modal
        centered
        open={true}
        onCancel={handleConfirmDeleteModel}
        className="custom-modal-col"
      >
        <div className="text-center">
          <img src={ModalImg} alt="cross" className="m-auto" />
          <h3 className="text-[22px] mt-[20px]">{modalTitle}</h3>
          <p className="modal-p-col mb-[30px] mt-[10px]">{modalMessage}</p>

          <Button
            buttonText="Confirm"
            padding="py-[15px] px-[80px]"
            text="text-[12px] 2xl:text-sm"
            width="100%"
            onClick={() => handleModelFunction()}
          />

          <button
            className="btn-secondary bg-transparent border-0 text-[#48BA89] text-sm mt-[30px]"
            onClick={handleConfirmDeleteModel}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ConfirmDeleteModal;
